module.exports = __webpack_public_path__ + "img/araby-ads-reference.55a7a44d.svg";